"use client"

import type { CountryCode } from "@/lib/phone"
import { useTranslations } from "@/lib/i18n/client"
import { ContactFormBase } from "./ContactForm"

interface AeronaveContactFormProps {
  aeronaveId: string
  referencia: string
  modeloNome: string
  domainKey: string
  defaultCountry?: CountryCode
}

export function AeronaveContactForm({
  aeronaveId,
  referencia,
  modeloNome,
  domainKey,
  defaultCountry = "BR",
}: AeronaveContactFormProps) {
  const { t } = useTranslations()

  const placeholderMensagem = t.form.contactPlaceholder
    .replace('{ref}', referencia)
    .replace('{model}', modeloNome)

  return (
    <section id="contato" className="mt-12 scroll-mt-24 rounded-xl bg-slate-50 px-4 py-12 md:px-8">
      <div className="mx-auto max-w-3xl">
        <h2 className="text-xl font-medium text-navy-900">
          {t.form.interestedTitle}
        </h2>
        <p className="mt-1 text-sm text-slate-500">
          {t.form.interestedSubtitle}
        </p>

        <ContactFormBase
          domainKey={domainKey}
          defaultCountry={defaultCountry}
          ids={{
            nome: "nome",
            email: "email",
            telefone: "telefone",
            cidade: "ac-cidade",
            uf: "ac-uf",
            mensagem: "mensagem",
          }}
          namePlaceholder={t.form.namePlaceholderShort}
          phoneLabel={t.form.phoneLabel}
          ufGridClassName="sm:grid-cols-[1fr_140px]"
          ufTriggerClassName="mt-1.5 w-full"
          messagePlaceholder={placeholderMensagem}
          messageRows={4}
          emptyMessageFallback={placeholderMensagem}
          extraPayload={{ aeronave_id: aeronaveId }}
          successMessage={t.form.sentSuccessContact}
          submitLabel={t.form.sendMessage}
          formClassName="mt-6 space-y-4"
        />
      </div>
    </section>
  )
}
